module.exports = __webpack_public_path__ + "static/media/carousel-1.ae20c64c.jpg";